
<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
	<h1 class="text-black title-6 md:title-3">Parámetros del sistema</h1>
		<div class="flex flex-col flex-wrap justify-center flex-1 py-16 md:justify-start sm:flex-row lg:grid-cols-3 md:flex-0 flex-zafari">
			<button
				class="flex flex-col items-center justify-center w-full h-32 gap-2 border-2 rounded-lg sm:max-w-56 border-primary-gray-02"
				routerLink="correos"
			>
				
                <mat-icon
                class="w-[48px] h-[40px] min-w-[48px] min-h-[40px] text-primary-gray-01"
                svgIcon="icons:mensaje-icon"
                ></mat-icon>
				<p class="paragraph-3 text-primary-gray-01">Mantenedor de correos</p>
			</button>

			<button
				class="flex flex-col items-center justify-center w-full h-32 gap-2 border-2 rounded-lg sm:max-w-56 border-primary-gray-02"
                routerLink="formulas"
			>
                <mat-icon
                class="w-[56.93px] h-[57.97px] min-w-[56.93px] min-h-[57.97px] text-primary-gray-01"
                svgIcon="icons:formulas-icon"
                ></mat-icon>
				<p class="paragraph-3 text-primary-gray-01">Fórmulas y parámetros</p>
			</button>

            <button
				class="flex flex-col items-center justify-center w-full h-32 gap-2 border-2 rounded-lg sm:max-w-56 border-primary-gray-02"
				routerLink="plantillas"
			>
                <mat-icon
                class="w-[48px] h-[48px] min-w-[48px] min-h-[48px] text-primary-gray-01"
                svgIcon="icons:plantillas-icon"
                ></mat-icon>
				<p class="paragraph-3 text-primary-gray-01">Plantillas de pagarés</p>
			</button>

            <button
				class="flex flex-col items-center justify-center w-full h-32 gap-2 border-2 rounded-lg sm:max-w-56 border-primary-gray-02"
				routerLink="folios"
			>
                <mat-icon
                class="w-[57.6px] h-[41.6px] min-w-[57.6px] min-h-[41.6px] text-primary-gray-01"
                svgIcon="icons:files-icon"
                ></mat-icon>
				<p class="paragraph-3 text-primary-gray-01">Mantenedor de folios</p>
			</button>
		</div>
</main>
